import React from 'react';
import PropTypes from 'prop-types';

const { Provider, Consumer } = React.createContext();

const FileUploadProvider = (props) => {
  const { assetManager, children } = props;

  return (
    <Provider
      value={{
        uploadFile: assetManager.uploadFile,
        addExternalAsset: assetManager.addExternalAsset,
        removeFile: assetManager.removeFile,
        resolveAsset: assetManager.resolveAsset,
      }}
    >
      {children}
    </Provider>
  );
};

FileUploadProvider.propTypes = {
  assetManager: PropTypes.object,
  children: PropTypes.any,
};

export { FileUploadProvider as Provider };
export { Consumer };
